<app-header
  *transloco="let t; read: 'candidates'"
  listType="candidate"
  [title]="t('pageTitle') | capitalize"
  [searchPlaceHolder]="t('searchTitle')"
  (onSearchInput)="onSearchInput($event)"
  [searchResults]="searchResults.asObservable()"
  [additionalSection]="storedQueriesDrawer"
></app-header>

<ng-template #storedQueriesDrawer>
  <app-storedqueries-drawer handle="HSCANDIDATES" [open]="showStoredQueries" (openClose)="showStoredQueries = $event" (filterData)="onStoredQueryClicked($event)"></app-storedqueries-drawer>
</ng-template>

<div class="page">
  <app-candidate-list [candidatesListing]="candidatesListing"></app-candidate-list>
  <app-no-results *ngIf="candidatesListing.length && candidatesListing[0].items.length == 0 && candidatesLoading == false"></app-no-results>
  <app-load-more-button
    [showLoadMoreButton]="showLoadMoreButton"
    (buttonClicked)="onNextPage()"
  ></app-load-more-button>
  <app-create-candidate></app-create-candidate>
</div>
